import { render, staticRenderFns } from "./referralManagement.vue?vue&type=template&id=3fe12ab7&"
import script from "./referralManagement.vue?vue&type=script&lang=js&"
export * from "./referralManagement.vue?vue&type=script&lang=js&"
import style0 from "./referralManagement.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports